import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourceModel } from '../../models/resource.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class GenericHttpService<T extends ResourceModel<T>> {

  constructor(
    private http: HttpClient,
    private tConstructor: { new(m: Partial<T>, ...args: any[]): T },
    protected apiUrl: string
  ) {}

  post(url: string, resource: Partial<T> & { toJson: () => T }): Observable<T> {
    return this.http
      .post<T>(url, resource.toJson())
      .pipe(map(result => new this.tConstructor(result)));
  }

  put(url: string, payload: any): Observable<T> {
    return this.http
      .put<T>(url, payload)                        // ✅ single object, not array
      .pipe(map(result => new this.tConstructor(result)));
  }

  get(url: string): Observable<T[]> {
    return this.http
      .get<T[]>(url)                               // ✅ interceptor handles auth
      .pipe(map(result => result.map(i => new this.tConstructor(i))));
  }

  getById(url: string): Observable<T[]> {
    return this.http
      .get<T[]>(url)
      .pipe(map(result => result.map(i => new this.tConstructor(i))));
  }

  delete(url: string): Observable<any> {
    return this.http.delete(url);                  // ✅ no array mapping on delete
  }
}